/**
 * DPL DEW — Admin Application Shell
 * Redirects to /admin which is handled by AdminApp.tsx
 */

import { Navigate } from 'react-router-dom';

const AdminLayout = () => {
  return <Navigate to="/admin" replace />;
};

export default AdminLayout;
